// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".reset-password .reset-password-message[data-v-6754969c]{gap:16px 28px}@media(max-width:599px){.reset-password .reset-password-message[data-v-6754969c]{flex-direction:column;text-align:center}}@media(max-width:599px){.reset-password .reset-password-message .v-card__title[data-v-6754969c]{justify-content:center}}", ""]);
// Exports
module.exports = exports;
